export default __webpack_public_path__ + "static/img-cms-holdings-86e126f8152787df08b5bbc4cf6e8d53.png";